import React from 'react';
import { Modal, Button, Form, Table, Spinner } from 'react-bootstrap';

const formatDate = (dateString) => {
    if (!dateString) return '--';
    try {
        // Handle ISO dates or YYYY-MM-DD string
        const date = new Date(dateString);
        
        // Use toLocaleDateString with options to handle different date formats cleanly
        return date.toLocaleDateString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric'
        });
        
    } catch {
        return '--';
    }
};

const formatCurrency = (amount) => {
    // Check for null/undefined/empty string, but allow 0
    if (amount === null || amount === undefined || amount === "") return '--';
    
    // Ensure the amount is treated as a number
    const numericAmount = parseFloat(amount);

    if (isNaN(numericAmount)) return '--';
    
    return `₹ ${numericAmount.toLocaleString('en-IN')}`;
};

const InvoicesModal = ({
    show,
    onHide,
    selectedCase,
    invoices,
    loadingInvoices,
    invoiceAmount,
    invoiceNumber,
    invoiceDate,
    setInvoiceAmount,
    setInvoiceNumber,
    setInvoiceDate,
    submitGenerateInvoice,
    invoiceLoading
}) => {
    // Validation requires all three fields for submission
    const isSubmitDisabled = invoiceLoading || 
                           !invoiceAmount || 
                           isNaN(invoiceAmount) || 
                           parseFloat(invoiceAmount) <= 0 || 
                           !invoiceNumber.trim() || 
                           !invoiceDate;

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Invoices & Generation
                    {selectedCase && (
                        <div className="text-muted fs-6 mt-1">
                            {selectedCase.customer_name} ({selectedCase.lan_number})
                        </div>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h5 className="mb-3">Generated Invoices</h5>
                <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {loadingInvoices ? (
                        <div className="text-center py-4"><Spinner animation="border" variant="primary" /></div>
                    ) : !invoices?.results || invoices.results.length === 0 ? (
                        <div className="text-center py-4"><p className="text-muted">No invoices found for this case.</p></div>
                    ) : (
                        <Table striped hover responsive>
                            <thead className="table-gray">
                                <tr>
                                    <th>Invoice ID</th>
                                    <th>Date</th>
                                    <th className="text-end">Amount (₹)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices.results.map((invoice) => (
                                    <tr key={invoice.id}>
                                        <td>{invoice.invoice_number || '--'}</td>
                                        {/* FIX 1: Use invoice.invoice_date (API value: "2025-10-08") */}
                                        <td>{formatDate(invoice.invoice_date)}</td>
                                        {/* FIX 2: Use invoice.invoice_amount (API value: "2343.00") */}
                                        <td className="text-end fw-bold">{formatCurrency(invoice.invoice_amount)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </div>

                <hr className="my-4" />

                <h5 className="mb-3">Generate New Invoice</h5>
                <Form>
                    <div className="row">
                        <Form.Group className="mb-3 col-md-4">
                            <Form.Label>Invoice Number *</Form.Label>
                            <Form.Control 
                                type="text" 
                                placeholder="Enter invoice number" 
                                value={invoiceNumber} 
                                onChange={(e) => setInvoiceNumber(e.target.value)} 
                                disabled={invoiceLoading} 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-4">
                            <Form.Label>Invoice Date *</Form.Label>
                            <Form.Control 
                                type="date" 
                                value={invoiceDate} 
                                onChange={(e) => setInvoiceDate(e.target.value)} 
                                disabled={invoiceLoading} 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-4">
                            <Form.Label>Invoice Amount *</Form.Label>
                            <Form.Control 
                                type="number" 
                                placeholder="Enter amount" 
                                value={invoiceAmount} 
                                onChange={(e) => setInvoiceAmount(e.target.value)} 
                                disabled={invoiceLoading} 
                                min="0" 
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={invoiceLoading}>Close</Button>
                <Button variant="primary" onClick={submitGenerateInvoice} disabled={isSubmitDisabled}>
                    {invoiceLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />}
                    {invoiceLoading ? 'Generating...' : 'Generate & Send'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InvoicesModal;